import React, { useState } from "react";
import { Plus, ArrowLeft, TagsFill, Diagram3Fill } from "react-bootstrap-icons";

import AddItemButton from 'components/Buttons/AddItemButton';
import SwipeableItem from 'components/SwipeableItem';

import { SwipeProvider } from 'hoc/SwipeContext';

import "./styles.css";

function List({
    items = [],
    onClickHandler,
    onDeleteHandler,
    onEditHandler,
    onBackClick,
    setCurrentState
}) {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    return (
        <div className="card card-paddings container-height">

            <div className="card-header card-header-paddings no-background no-border">
                <div className="p-2">
                    <h3>Charts</h3>
                    <span>Create custom charts using tags and values combination</span>
                </div>
            </div>

            <div className="card-body overflow-auto p-0">

                {items.length > 0 ? (
                    <div className="flex-grow-1 overflow-auto">
                        <SwipeProvider>
                            <ul className="list-group list-group-flush w-100 mb-1">
                                {items.map((item, index) => (
                                    <SwipeableItem
                                        key={index}
                                        id={item.uid || index}
                                        onEdit={onEditHandler ? () => onEditHandler(item) : null}
                                        onDelete={onDeleteHandler ? () => onDeleteHandler(item.uid) : null}
                                        onClick={() => onClickHandler(item)}
                                        className="position-relative overflow-hidden tags-swipeable-wrapper"
                                    >
                                        <li
                                            key={index}
                                            style={{
                                                cursor: "pointer",
                                            }}
                                            className={`list-group-item w-100 d-flex align-items-center px-2 ${!isMobile ? 'list-group-item-action' : ''}`}
                                        >
                                            <span className="flex-grow-1">{item.title}</span>

                                            <div className="d-flex flex-wrap gap-2 justify-content-end">
           
                                                <div className="d-flex align-items-center">
                                                    <Diagram3Fill size={16} />
                                                    {item.values.length}
                                                </div>
                                            
                                                <div className="d-flex gap-1 align-items-center">
                                                    <TagsFill size={16} />
                                                    {item.tags.length}
                                                </div>
                                                
                                            </div>
                                        </li>
                                    </SwipeableItem>
                                ))}
                            </ul>
                        </SwipeProvider>
                    </div>

                ) : !isMobile ? (
                    <div
                        className="d-flex flex-column justify-content-center align-items-center w-100 h-100"
                        onClick={() => setCurrentState('add')}
                        style={{ cursor: "pointer" }}
                    >
                        <Plus size={80} className="text-primary" />
                        <p className="text-muted mt-3">Click to add your first chart</p>
                    </div>
                ) : (
                    <></>
                )}

            </div>


            {isMobile && (
                <div className="card-footer card-footer-paddings border-top no-background">
                    <div className="d-flex justify-content-between">
                        <button
                            type="button"
                            className="btn btn-success"
                            onClick={() => setCurrentState('add')}
                        >
                            Add
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary ms-auto"
                            onClick={(e) => {
                                e.preventDefault();

                                onBackClick();
                            }}
                        >
                            <ArrowLeft className="me-2" />
                            Back
                        </button>
                    </div>
                </div>
            )}


            {!isMobile && items.length > 0 && (
                <div
                    className="card-footer card-footer-paddings no-border no-background mt-auto"
                >
                    <AddItemButton onClick={() => setCurrentState('add')} />
                </div>
            )}

        </div>
    );
};

export default List;
